<template>
  <div class="emb-privacy-policy-wrap">
    <emb-page-title
      :heading="TopSection.Heading"
      :subHeading="TopSection.Sub_Heading"
      :image="TopSection.Image_1366_x_552px"
    ></emb-page-title>
    <div class="section-gap bg-white">
      <div class="container">
        <div class="privacy-page">
          <div
            class="emb-card mb-12 pa-6"
            v-for="(policy,key) in MainContent.Privacy_Policy_List"
            :key="key"
          >
            <h4 class="mb-4">{{policy.Title}}</h4>
            <div v-html="policy.Privacy_Policy_Content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "Api";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../services/utils/cms-helper";
export default {
   computed: {
    ...mapGetters(["rtlLayout","selectedLocale"])
  },
  data() {
    return {
      TopSection: {},
      MainContent: {}
    };
  },
   watch: {
    selectedLocale: function () {
     this.getPrivacyPolicyData();
    
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPrivacyPolicyData();
  },
  methods: {
    getPrivacyPolicyData: function() {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "21 Privacy Policy/21 Privacy Policy/21 Privacy Policy.ftl",
        lang: language,
        successCallback: function(response) {
          var res = response.data;
          if (res.area_List) {
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Top_Section",
              res.area_List
            );
            self.TopSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
            var Main = self.cmsRequestFunctions.pluck(
              "Main_Content",
              res.area_List
            );
            self.MainContent = self.cmsRequestFunctions.getAllMapData(
              Main[0].component
            );
          }
        },
        errorCallback: function(error) {
          console.log(error);
        }
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    }
    // getPrivacyPolicyData() {
    //   api
    //     .get("privacy_policy.json")
    //     .then(response => {
    //       this.policylist = response.data;
    //       // console.log(response.data);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
  }
};
</script>
